var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 138,
    viewBox: "0 0 190 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.651 0H56.7608C26.8465 0 1.16545 23.4587 0.0366159 53.4179C-1.09222 85.073 24.0244 110.793 55.3497 110.793H90.9081C93.1658 110.793 94.8591 112.489 94.8591 114.75V134.817C94.8591 137.643 98.2456 139.056 100.221 137.078L125.338 111.923C126.184 111.075 127.031 110.793 128.16 110.793H133.24C163.154 110.793 188.835 87.3341 189.964 57.3748C191.093 26.0024 165.694 0 134.651 0Z",
    fill: "#47B972"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_379_20246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.62 15.2227C121.28 15.6273 120.055 16.3567 119.042 17.3705L82.7312 53.6803C81.6973 54.7142 80.9825 55.9484 80.5852 57.2582L115.613 50.2526L122.62 15.2227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.479 38.6188L131.231 17.37C130.157 16.2964 128.845 15.5438 127.413 15.1562L119.904 52.7039C119.718 53.6316 118.993 54.3573 118.065 54.5428L80.5169 62.0526C80.8978 63.4515 81.6345 64.7736 82.7313 65.8704L84.5977 67.7368L75.686 76.6486C74.7711 77.5641 74.7711 79.0479 75.6866 79.9634C76.1444 80.4205 76.7437 80.6494 77.3437 80.6494C77.9437 80.6494 78.543 80.4205 79.0008 79.9634L87.9126 71.0516L91.698 74.837L75.686 90.849C74.7711 91.7639 74.7711 93.2483 75.6866 94.1632C76.1444 94.621 76.7437 94.8499 77.3437 94.8499C77.9437 94.8499 78.543 94.621 79.0008 94.1632L95.0128 78.1512L98.7982 81.9373L89.887 90.849C88.9715 91.7639 88.9715 93.2483 89.887 94.1632C90.3442 94.621 90.9442 94.8499 91.5441 94.8499C92.1441 94.8499 92.7435 94.621 93.2012 94.1632L102.113 85.2521L103.979 87.1185C105.603 88.7415 107.767 89.6356 110.074 89.6356C112.382 89.6356 114.546 88.7415 116.169 87.1185L152.479 50.8087C155.84 47.4475 155.84 41.9794 152.479 38.6188Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_379_20246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    transform: "translate(75 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmail);
export default __webpack_public_path__ + "static/media/cmail.26db2ef77e880034f170e2823f6a4e05.svg";
export { ForwardRef as ReactComponent };